exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BuildPortfolio {\n  margin: 10px;\n  -webkit-transition-duration: 0.3s;\n  -o-transition-duration: 0.3s;\n  transition-duration: 0.3s; }\n  .BuildPortfolio_card_holder {\n    margin: 0 25px; }\n    .BuildPortfolio_card_holder .slick-track {\n      display: block; }\n      .BuildPortfolio_card_holder .slick-track::after {\n        clear: both;\n        height: 0; }\n    .BuildPortfolio_card_holder .slick-next::before {\n      content: none; }\n    .BuildPortfolio_card_holder .slick-prev::before {\n      content: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/build_portfolio/BuildPortfolio.style.scss
// module id = 1637
// module chunks = 0